module.exports = __webpack_public_path__ + "static/img/Tela de os.99bb8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de os.png
// module id = JPKr
// module chunks = 0